import {Injectable} from '@angular/core';
import {NzDrawerService} from 'ng-zorro-antd/drawer';

@Injectable()
export class AsideService {
    constructor(private drawerService: NzDrawerService) {}

    open(component) {
        return this.drawerService.create({
            nzContent: component,
            nzWidth: 'initial',
            nzKeyboard: false,
            nzClosable: false,
            nzMaskClosable: false,
        });
    }
}
